import { render, staticRenderFns } from "./CategoryInfo.vue?vue&type=template&id=63b0299b&scoped=true"
import script from "./CategoryInfo.vue?vue&type=script&lang=js"
export * from "./CategoryInfo.vue?vue&type=script&lang=js"
import style0 from "./CategoryInfo.vue?vue&type=style&index=0&id=63b0299b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0299b",
  null
  
)

export default component.exports